import { useState } from "react";
import { useContext } from "react";

import { ProjectUser } from "@nens/rana/api-v1";
import { TenantContext } from "@nens/ranalib";

import { useRanaSearchState } from "@/hooks/router/rana-search-state";
import { useProjectUserListQuery } from "@/queries/query-project-users";
import { getCompleteName } from "@/utils/get-complete-name";

type ProjectUserListModalType =
  | {
      type: "invite";
    }
  | {
      type: "remove";
      users: ProjectUser[];
    }
  | { type: "change-role"; users: ProjectUser[] }
  | null;

export function useProjectUserList() {
  const [openModal, setOpenModal] = useState<ProjectUserListModalType>(null);
  const [searchString, setSearchString] = useRanaSearchState("puSearch", "");

  const { user } = useContext(TenantContext);
  const tenantName = getCompleteName(user);
  const usersListQuery = useProjectUserListQuery(searchString);
  const usersList = usersListQuery?.data?.items ?? [];

  return {
    tenantName,
    usersList,
    usersListQuery,
    openModal,
    searchString,
    setSearchString,
    changeUsersRole: (users: ProjectUser[]) => setOpenModal({ type: "change-role", users }),
    inviteUser: () => setOpenModal({ type: "invite" }),
    removeUsers: (users: ProjectUser[]) => setOpenModal({ type: "remove", users }),
    closeModal: () => setOpenModal(null),
  };
}
